/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  // O servidor recusa a exclusão de uma caixa que ainda tem conversas enquanto
  // a requisição não repetir, em `confirm_destroy_history`, a mesma quantidade
  // de conversas que ele está prestes a apagar. Sem o argumento a chamada
  // continua idêntica à de antes, que é o caminho usado pelo store.
  delete(inboxId, { confirmDestroyHistory } = {}) {
    if (confirmDestroyHistory === undefined || confirmDestroyHistory === null) {
      return axios.delete(`${this.url}/${inboxId}`);
    }

    return axios.delete(`${this.url}/${inboxId}`, {
      params: { confirm_destroy_history: confirmDestroyHistory },
    });
  }

  // Leitura do estado da conexão de WhatsApp da caixa. O servidor responde 502
  // quando não conseguiu falar com o provedor, e essa diferença precisa chegar
  // intacta à tela: apresentar falha de comunicação como desconexão levaria o
  // atendente a ler um QR Code numa conexão que está no ar, derrubando-a.
  getUazapiConnectionStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/uazapi_status`);
  }

  // Inicia um ciclo de conexão e devolve o QR Code quando ele já existe. O corpo
  // vai vazio de propósito: número viraria pareamento por código, e nome de
  // sistema renomearia o aparelho no celular do cliente.
  connectUazapi(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi_connect`);
  }
}

export default new Inboxes();
